import { MapContext } from '#contexts/MapContext';
import React from 'react';
import { loadMapApi } from './LoadMapApi';

export const MapProvider = ({ googleMapKey, children }: { googleMapKey: string; children: any }) => {
  const [scriptLoaded, setScriptLoaded] = React.useState(false);

  React.useEffect(() => {
    if (!googleMapKey) {
      return;
    }

    const googleMapScript = loadMapApi(googleMapKey);

    const handleLoad = () => {
      setScriptLoaded(true);
    };

    googleMapScript.addEventListener('load', handleLoad);

    return () => {
      googleMapScript.removeEventListener('load', handleLoad);
    };
  }, [googleMapKey]);

  const value = React.useMemo(
    () => ({
      scriptLoaded
    }),
    [scriptLoaded]
  );

  return <MapContext.Provider value={value}>{children}</MapContext.Provider>;
};
